import $ from 'jquery';
import 'jquery.cookie';

function cookieHelper() {
  const lang = $('html').attr('lang');
  const cookies = $.cookie(`jhd;sjdj${lang}`);

  if (!cookies) {
    $.cookie(`jhd;sjdj${lang}`, 'sdj837rgdhbsj');
  }
}

cookieHelper();
